export default {
    model: {
        email: {
            label: "E-mail",
            placeholder: "Nome ou e-mail do delegado",
            notFound: "Usuários não encontrados"
        },
        start_on: {
            label: "Data de início",
            placeholder: "Data de início da delegação"
        },
        end_on: {
            label: "Data de término",
            placeholder: "Opcional"
        },
        accept: {
            tip: "Ao delegar sua responsabilidade de aprovação, você certifica que assumirá a responsabilidade por quaisquer pedidos aprovados por seu delegado.",
            label: "aceito"
        }
    },
    buttons: {
        submit: {
            cta: "Confirmar",
            processing: "Economizando"
        },
        close: {
            cta: "Cancelar"
        }
    },
    saved: "Salvo"
}